import moment from 'moment';

import { addMaskCpf, cloneObject } from '../../../../utils';

import schema from '../Titular/schema';

function translateToSchema(beneficiarios) {
    const translated = beneficiarios.map((beneficiario) => {
        const translation = cloneObject(schema);

        translation.cardNumber.value = beneficiario.numeroCarteira;
        translation.company.value = beneficiario.nomeEmpresa;
        translation.company.lookup = beneficiario.nomeEmpresa;
        translation.contractName.value = beneficiario.nomeContrato;
        translation.cpf.value = addMaskCpf(beneficiario.cpf);
        translation.cpf.unmaskedValue = beneficiario.cpf;
        translation.fullName.value = beneficiario.nome;
        translation.healthPlan.value = beneficiario.codigoPlano;
        translation.healthPlan.lookup = beneficiario.nomePlano;
        translation.dateStartPlan.value = moment(beneficiario.dataInclusao, 'MM/DD/YYYY HH:mm:ss').toISOString();

        return translation;
    });

    return translated || [];
}

export default translateToSchema;
